import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  AfterViewInit,
  OnDestroy,
  ElementRef,
  Renderer2,
  NgZone,
} from '@angular/core';
import { NavStateService } from '@shared/service/nav-state.service';
import { CardConfig } from '@shared/module/card/model';
import { menuActionRelatedPermission, MenuActionType } from '@shared/model';
import { MenuHelperUtils } from '@shared/helper';
import { FormControl, FormGroup } from '@angular/forms';
import { VisualPrestationType } from '@dashboard/module/visual-prestation-type/model';
import { Team } from '@team/model';
import { ConfirmService } from '@shared/component/confirm-dialog/service/confirm.service'; // 👈 adapte le chemin selon ton arborescence

@Component({
  selector: 'app-list-main-page',
  templateUrl: './list-main-page.component.html',
  styleUrls: ['./list-main-page.component.scss'],
})
export class ListMainPageComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy
{
  @Input() list!: any[];
  @Input() entity!: string;
  @Input() config!: CardConfig;
  @Input() canFilter: boolean = true;
  @Input() canFilterDeleted: boolean = false;
  @Input() showLoadMore: boolean = false;
  @Input() isCenter: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() selectedId: string | undefined = undefined;
  @Input() canCollapse: boolean = true;
  @Output() onChoose = new EventEmitter<any>();
  @Output() onLoadMore = new EventEmitter<void>();
  @Output() onSearch = new EventEmitter<any>();
  @Output() onDeletedFilter = new EventEmitter<boolean>();
  /** Emit when the list collapsed state changes so parent can react and adjust layout */
  @Output() collapsedChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() onActionClick: EventEmitter<{ action: MenuActionType; data: any }> =
    new EventEmitter<{
      action: MenuActionType;
      data: any;
    }>();
  @Output() selectedIdChange: EventEmitter<string | undefined> =
    new EventEmitter<string | undefined>();

  duplicateLoading: boolean = false;
  deleteLoading: boolean = false;
  currentChoose?: any;
  duplicate?: any;
  softDeleted?: any;
  restore?: any;
  formGroup!: FormGroup;
  readonly deletedFilterOptions = [
    {
      label: 'common.filter.deleted.exclude',
      value: false,
    },
    {
      label: 'common.filter.deleted.only',
      value: true,
    },
  ];
  readonly colors: string[] = ['#304858', '#fd7e14', '#ffc107'];

  private _floatingBtnEl: HTMLElement | null = null;
  private _originalParent: Node | null = null;

  constructor(
    private navStateService: NavStateService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private ngZone: NgZone,
    private confirmService: ConfirmService
  ) {}

  ngOnInit(): void {
    this.initFormGroup();
    
    if (this.canCollapse) {
      this.loadCollapsedState();
    } else {
      this.collapsed = false;
      // Force update global state to not collapsed if this component cannot collapse
      // But be careful not to override user preference for other pages if this is page-specific.
      // Actually, if canCollapse is false, we just want THIS instance to be open.
      // We should probably emit the state change.
      this.collapsedChange.emit(false);
      
      // Also force update the navStateService to ensure the layout is correct
      // This is important if the user navigated from a page where the list was collapsed
      setTimeout(() => {
        this.navStateService.setCollapsed(false);
      });
    }

    // Sync with global nav state: update internal collapsed when global changes
    try {
      if (this.canCollapse) {
        this.navStateService.collapsed$.subscribe((v) => {
          if (this.collapsed !== v) {
            this.collapsed = v;
            try {
              this.collapsedChange.emit(this.collapsed);
            } catch (e) {}
          }
        });
      }
    } catch (e) {
      // ignore
    }

    this.duplicate = {
      icon: MenuHelperUtils.DUPLICATE_ICON,
      title: `menu.${this.entity}`,
      type: MenuActionType.DUPLICATE,
    };

    this.softDeleted = {
      icon: MenuHelperUtils.DELETE_ICON,
      title: `menu.${this.entity}`,
      type: MenuActionType.SOFTDELETE,
    };

    this.restore = {
      icon: MenuHelperUtils.RESTORE_ICON,
      title: `menu.${this.entity}`,
      type: MenuActionType.ROLLBACK,
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.entity == 'prestation-type') {
      this.list.forEach((pt: any) => {
        pt.color = pt.visualPrestationTypes.find(
          (vpt: VisualPrestationType) => vpt.type === 'default'
        ).colorText;
        pt.background = pt.visualPrestationTypes.find(
          (vpt: VisualPrestationType) => vpt.type === 'default'
        ).colorBackground;
      });
    }

    if (this.entity === 'team') {
      // If it is the team entity, we need to sort by name and group by hierarchy
      this.prepareTeamList();
    }

    if (this.entity === 'remember') {
      this.prepareRememberList();
    }

    if (
      this.entity === 'employee' &&
      this.list?.length > 0 &&
      changes['list']
    ) {
      this.list.sort((a, b) => (a.lastname > b.lastname ? 1 : -1));

      if (this.selectedId === undefined) {
        this.onChoose.emit(this.list[0]);
      }
    }
  }

  onClick(item: any): void {
    this.currentChoose = item;
    this.selectedIdChange.next(undefined);
    if (this.entity === 'team') {
      this.onChoose.emit({
        ...this.currentChoose,
        name: this.currentChoose.name.trimStart(),
      });
    } else {
      this.onChoose.emit(this.currentChoose);
    }
  }

  //onClickAction(action: MenuActionType, data: any) {
  //  if (action == this.softDeleted.type) {
  //    this.deleteLoading = true;
  //    this.onActionClick.emit({action, data});
  //    this.deleteLoading = false;
  //  } else if (action == this.duplicate.type) {
  //    this.duplicateLoading = true;
  //    this.onActionClick.emit({action, data});
  //    this.duplicateLoading = false;
  //  } else {
  //    this.onActionClick.emit({action, data});
  //  }
  //}

  onClickAction(action: MenuActionType, data: any) {
    if (action === this.softDeleted.type) {
      this.confirmService.open(
        'action.deleted_confirm',
        data?.name ? data?.name : data?.title ? data?.title : '',
        () => {
          this.deleteLoading = true;
          this.onActionClick.emit({ action, data });
          this.deleteLoading = false;
        }
      );
    } else if (action === this.duplicate.type) {
      this.confirmService.open(
        'action.duplicate_confirm',
        data?.name ? data?.name : data?.title ? data?.title : '',
        () => {
          this.duplicateLoading = true;
          this.onActionClick.emit({ action, data });
          this.duplicateLoading = false;
        }
      );
    } else if (action === this.restore.type) {
      this.confirmService.open(
        'action.restore_confirm',
        data?.name ? data?.name : data?.title ? data?.title : '',
        () => {
          this.onActionClick.emit({ action, data });
        }
      );
    } else {
      this.onActionClick.emit({ action, data });
    }
  }

  onDeletionFilterChange(x: any) {
    if (x !== undefined) {
      this.onDeletedFilter.emit(x);
    }
  }

  loadMore() {
    this.onLoadMore.emit();
  }

  private initFormGroup(): FormGroup {
    this.formGroup = new FormGroup({
      search: new FormControl(''),
    });
    this.formGroup.valueChanges.subscribe(() => {
      this.onSearch.emit(this.formGroup.value['search']);
    });

    return this.formGroup;
  }

  // Group sections with their children and add indentation for the children
  private prepareTeamList(): void {
    interface TeamWithChildren extends Team {
      children: TeamWithChildren[];
    }

    const convertToTeamWithChildren = (team: Team): TeamWithChildren => {
      const children = this.list.filter((t) => t.parent?.id === team.id);
      return {
        ...team,
        children: children.length
          ? children.map((c) => convertToTeamWithChildren(c))
          : [],
      };
    };

    const flattenTeamWithChildren = (
      team: TeamWithChildren,
      prependToName: string = ''
    ): Team[] => {
      const updatedTeamValue = {
        ...team,
        name: prependToName + team.name,
      } as Team;

      if (team.children.length === 0) {
        return [updatedTeamValue];
      }

      return [updatedTeamValue].concat(
        team.children.flatMap((c) =>
          flattenTeamWithChildren(c, `\t ${prependToName}`)
        )
      );
    };

    this.list = this.list
      .filter((t) => !t.parent?.id)
      .map((t) => convertToTeamWithChildren(t))
      .sort((a, b) => a.name.localeCompare(b.name))
      .flatMap((t) => flattenTeamWithChildren(t));
  }

  public getTabs(str: string): string[] {
    return str.match(/\t/g) || [];
  }

  // If we have remembers, add the flags that will affect if it is dashed or not or if it has a badge next to it
  private prepareRememberList(): void {
    const now = new Date().setHours(0, 0, 0, 0);

    const withoutTime = (date: Date) => {
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d;
    };

    this.list.forEach((r) => {
      if (withoutTime(r.dateToPop).getTime() < now) {
        r.expired = true;
      }
    });
  }

  public readonly menuActionRelatedPermission = menuActionRelatedPermission;

  // Collapsible state: when true the list is collapsed (hidden)
  collapsed: boolean = true;

  ngAfterViewInit(): void {
    // Move the floating toggle to document.body to avoid being clipped by transformed ancestors (mat-tab-body)
    try {
      this.ngZone.runOutsideAngular(() => {
        const host: HTMLElement = this.elementRef.nativeElement as HTMLElement;
        const btn = host.querySelector(
          '.floating-toggle'
        ) as HTMLElement | null;
        if (btn && document && document.body) {
          this._floatingBtnEl = btn;
          this._originalParent = btn.parentNode;
          // detach and append to body
          this.renderer.removeChild(this._originalParent, btn);
          this.renderer.appendChild(document.body, btn);
        }
      });
    } catch (e) {
      // ignore
    }
  }

  ngOnDestroy(): void {
    // restore the floating button to its original place if possible
    try {
      if (this._floatingBtnEl && this._originalParent) {
        this.renderer.removeChild(document.body, this._floatingBtnEl);
        this.renderer.appendChild(this._originalParent, this._floatingBtnEl);
      }
    } catch (e) {
      // ignore
    }
  }

  toggleCollapsed(persist: boolean = true) {
    this.collapsed = !this.collapsed;
    try {
      const key = `list-main-page-collapsed-${this.entity ?? 'global'}`;
      if (persist) {
        localStorage.setItem(key, String(this.collapsed));
      } else {
        localStorage.removeItem(key);
      }
    } catch (e) {
      // ignore storage errors
    }
    // Inform parent about the new collapsed state so it can adapt layout (remove blank space)
    try {
      this.collapsedChange.emit(this.collapsed);
    } catch (e) {
      // ignore emit errors
    }
    // Update global nav state so all pages follow this change
    try {
      this.navStateService.setCollapsed(this.collapsed);
    } catch (e) {
      // ignore
    }
  }

  private loadCollapsedState() {
    try {
      const key = `list-main-page-collapsed-${this.entity ?? 'global'}`;
      const v = localStorage.getItem(key);
      if (v !== null) {
        this.collapsed = v === 'true';
      }
    } catch (e) {
      // ignore
    }
    // Emit initial state so parent can adapt immediately on init
    try {
      this.collapsedChange.emit(this.collapsed);
    } catch (e) {
      // ignore emit errors
    }
    // Sync global nav state too
    try {
      this.navStateService.setCollapsed(this.collapsed);
    } catch (e) {
      // ignore
    }
  }
}
